// extracted by mini-css-extract-plugin
export default {"label":"W6M4aj"};